import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { GlobalVariable } from "app/global/global";

@Injectable({
  providedIn: "root",
})
export class MovimientoService {
  private url = GlobalVariable.BASE_API_URL + "api/movimiento/";

  constructor(private http: HttpClient) {}

  listarTodos(filtros?: any): Observable<any> {
    let params = new HttpParams();
    if (filtros?.fechaDesde) params = params.set("fecha_desde", filtros.fechaDesde);
    if (filtros?.fechaHasta) params = params.set("fecha_hasta", filtros.fechaHasta);
    if (filtros?.tipo) params = params.set("tipo", filtros.tipo);
    if (filtros?.idMedico) params = params.set("id_medico", filtros.idMedico);
    if (filtros?.estado) params = params.set("estado", filtros.estado);
    if (filtros?.subTipo) params = params.set("sub_tipo", filtros.subTipo);
    return this.http.get(this.url + "listar-todos", { params });
  }

  listarPorMedico(idMedico: number, filtros?: any): Observable<any> {
    let params = new HttpParams();
    if (filtros?.fechaDesde) params = params.set("fecha_desde", filtros.fechaDesde);
    if (filtros?.fechaHasta) params = params.set("fecha_hasta", filtros.fechaHasta);
    if (filtros?.tipo) params = params.set("tipo", filtros.tipo);
    if (filtros?.estado) params = params.set("estado", filtros.estado);
    if (filtros?.subTipo) params = params.set("sub_tipo", filtros.subTipo);
    return this.http.get(this.url + "listar-por-medico/" + idMedico, { params });
  }

  crear(movimiento: any): Observable<any> {
    return this.http.post(this.url + "crear", movimiento);
  }

  editar(id: number, movimiento: any): Observable<any> {
    return this.http.put(this.url + "editar/" + id, movimiento);
  }

  borrar(id: number): Observable<any> {
    return this.http.delete(this.url + "borrar/" + id);
  }
}
